<template>
	<modal :show.sync="syncModal" footerClasses="d-none">
		<form-company-role>
			<template #return>
				<base-button
					@click.stop="syncModal = false"
					:disabled="formProcessing"
					type="white"
					size="md"
					class="form-btn bg-transparent px-0 font-weight-normal shadow-none"
					>Cancel</base-button
				>
			</template>
		</form-company-role>

		<template #footer>
			<div class="sr-only"></div>
		</template>
	</modal>
</template>

<script>
import FormCompanyRole from "@components/FormCompanyRole";

export default {
	name: "modal-company-role",
	components: {
		FormCompanyRole,
	},
	data() {
		return {
			syncModal: false,
			formProcessing: false,
		};
	},
	mounted() {
		this.$bus.trackEvent("toggle-modal", (payload) => {
			if ("company-role" === payload.key) this.syncModal = payload.active;
		});

		this.$bus.trackEvent("company-role-form-processing", (payload) => {
			this.syncModal = payload;
			this.formProcessing = payload;
		});
	},
};
</script>
